import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PagePadding from "../layouts/PagePadding";
import { loginIn } from "../slice/user/userSlice";
import Input from "../components/form-input/Input";
import InputPassword from "../components/form-input/InputPassword";
import Btn from "../components/btn/create-account/Btn";
import Outer from "../layouts/form/Outer";
import Inner from "../layouts/form/Inner";
import Footer from "../components/onboarding/Footer";
import { handleDisable } from "../utils/btn/handleDisable";
import { useNavigate, Link } from "react-router-dom";
import req from "../axios/interceptedAxiosInstance";
import IsLoading from "../components/loading/IsLoading";
import { successToast } from "../notification/notification";
import useAuth from "../hooks/useAuth";

export const SignIn = ({ setLoading }) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [reminder, setReminder] = useState(false);

  const navigate = useNavigate();

  const loginBody = {
    email: email,
    password: password,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await req.post("auth/login", loginBody);
      const { data } = response;
      const { accessToken, data: userData } = data;
      const {
        email,
        user_name,
        first_name,
        id,
        is_verified,
        last_name,
        phone_number,
        roles,
      } = userData;
      const persistentData = {
        accessToken: accessToken,
        email: email,
        user_name: user_name,
        first_name: first_name,
        id: id,
        is_verified: is_verified,
        last_name: last_name,
        phone_number: phone_number,
        roles,
      };
      successToast(response.data.message);
      dispatch(loginIn(persistentData));
      setLoading(false);
      navigate("/communities");
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  let disable = handleDisable([email, password]);

  useEffect(() => {
    if (user?.data) navigate("/communities");
  }, [navigate, user?.data]);

  return (
    <div className="relative">
      <PagePadding>
        <Outer>
          <Inner>
            <div className="mt-4 flex w-fit gap-14 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-chevron-left cursor-pointer"
                viewBox="0 0 16 16"
                onClick={() => navigate(-1)}
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
              <h4 className="font-normal text-2xl">Welcome Back</h4>
            </div>

            <form className="mt-8">
              <Input
                type="email"
                placeholder="Email Address"
                required={true}
                value={email}
                onValueChange={setEmail}
              />
              <div className="relative">
                <InputPassword
                  placeholder="Password"
                  password={password}
                  setPassword={setPassword}
                />
              </div>
              <Link to="/forgot-password">
                <p className="text-sm font-normal text-logoRed mt-5">
                  Forgot Password?
                </p>
              </Link>
              <div className="mt-7 flex items-center gap-3">
                <input
                  type="checkbox"
                  value={reminder}
                  onChange={() => setReminder(!reminder)}
                />
                <p className="text-sm font-normal">Remember me</p>
              </div>
              <div>
                <Btn
                  innerText="Submit"
                  inactive="bg-darkGrey"
                  active="bg-logoRed"
                  onclick={handleSubmit}
                  disable={disable}
                />
              </div>
            </form>
          </Inner>
        </Outer>
      </PagePadding>
      <Footer />
    </div>
  );
};

export default IsLoading(SignIn, "Signing you in");
